// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { getItem } from '@/items/api/get-item';
import { ItemPricingForm } from '@/items/components/item-pricing-form';
import { Alert, AlertTitle } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/catalog/items/$itemKey/pricing')({
  component: ItemPricingRoute,
});

function ItemPricingRoute() {
  const { itemKey } = Route.useParams();

  const { data } = useSuspenseQuery({
    queryKey: ['item', itemKey],
    queryFn: () => getItem(itemKey),
  });

  return (
    <HardfinTabCardWrapper title="Pricing">
      <Alert severity="info" sx={{ margin: 2 }}>
        <AlertTitle>Item pricing defaults</AlertTitle>
        These values are used to prefill new project line items and invoice line
        items (charges) for <strong>{data.item.name}</strong>. They can be
        overridden before saving an individual line item or charge.
      </Alert>
      <ItemPricingForm item={data.item} sx={{ padding: 2, paddingTop: 1 }} />
    </HardfinTabCardWrapper>
  );
}
